module.exports = __webpack_public_path__ + "img/loading-iso.d6204736.gif";